module.exports = __webpack_public_path__ + "static/media/poweredbytnns-purple.4a36b3f8.png";